// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".style__dropdown_picture___3hcZW{height:30px;width:30px;border-radius:50%}\n", "",{"version":3,"sources":["webpack://./src/user/style.scss"],"names":[],"mappings":"AAAA,iCACE,WAAY,CACZ,UAAW,CACX,iBAAkB","sourcesContent":[".dropdown_picture {\n  height: 30px;\n  width: 30px;\n  border-radius: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dropdown_picture": "style__dropdown_picture___3hcZW"
};
export default ___CSS_LOADER_EXPORT___;
